module.exports = __webpack_public_path__ + "img/9791156755036.604cc3c9.jpg";